'use client';
import React from 'react';
import { OrderConfirmation as Shared } from '@launchstore/shared-puck';
import { useOrderData } from '@/lib/hooks/useOrderData';

const SharedRender = (Shared as any).render;

/**
 * Storefront OrderConfirmation — injects the real order's number, email and
 * links from the Puck `context`. Falls back to the shared placeholder when no
 * order is present (editor preview).
 */
function OrderConfirmationImpl(props: any) {
  const { order, countryCode } = useOrderData();
  if (!order) {
    return <SharedRender {...props} />;
  }
  const base = countryCode ? `/${countryCode}` : '';
  const orderId =
    order.display_id != null ? `#${order.display_id}` : order.id;
  return (
    <SharedRender
      {...props}
      orderId={orderId}
      email={order.email}
      createdAt={order.created_at}
      viewOrderHref={`${base}/account/orders/${order.id}`}
      continueShoppingHref={`${base}/`}
    />
  );
}

export const OrderConfirmation: any = {
  ...Shared,
  render: (props: any) => <OrderConfirmationImpl {...props} />,
};

export default OrderConfirmation;
